import React from "react";
import Songitem from "./Songitem";
import { useProvider } from "./StateProvider";

const Musiclist = ({ songlist }) => {
  const { user, storage, db } = useProvider();

  const addSong = (e) => {
    const file = e.target.files[0];
    if (file.type.substring(0, 5) === "audio") {
      const storageRef = storage.ref();
      const fileRef = storageRef.child(file.name);
      var fileUrl = "";
      fileRef
        .put(file)
        .then((result) => {
          fileRef
            .getDownloadURL()
            .then((url) => {
              fileUrl = url;
              db.collection("songs").add({
                userId: user.uid,
                userName: user.displayName,
                songName: file.name,
                songUrl: fileUrl,
                numberOfLikes: 0,
                likedBy: [],
              });
            })
            .catch((err) => {
              alert("file upload failed");
            });
        })
        .catch((err) => {
          alert("cant fetch download url");
        });
    } else {
      alert("Upload only audio file");
    }
  };
  return (
    <>
      <div className="container">
        {songlist.map((song) => {
          return <Songitem key={song.id} {...song} id={song.id} />;
        })}

        <label
          className="btn btn-primary rounded-circle shadow d-flex align-items-center justify-content-center"
          style={{
            position: "fixed",
            bottom: "2rem",
            right: "10rem",
            height: "50px",
            width: "50px",
          }}
        >
          <i className="fas fa-plus">
            <input
              type="file"
              accept="audio/*"
              onChange={addSong}
              style={{ display: "none" }}
            />
          </i>
        </label>
      </div>
    </>
  );
};

export default Musiclist;
